// curatedStore.ts
import { defineStore } from "pinia";
import {ref, watch} from "vue";
import * as CmsService from "../services/cms.service";
import {useLocalization} from "@/locales/localization";


export const useCuratedStore = defineStore('curatedStore', () => {
    const curatedOffers = ref([]);
    const loadingCurated = ref(false);
    const { currentLocale } = useLocalization();

    function fetchCuratedOffers() {
        loadingCurated.value = true;
        CmsService.getCuratedOffers(currentLocale.value)
            .then((response) => {
                curatedOffers.value = response.data.results;
                console.log("CURATED OFFERS VALUE: ", curatedOffers.value)
                console.log("RESPONSE: ", response)
            })
            .catch((error) => {
                console.error("Error fetching curated offers:", error);
                curatedOffers.value = [];
            })
            .finally(() => {
                loadingCurated.value = false;
            });
    }


    watch(currentLocale, (newLocale, oldLocale) => {
        if (newLocale !== oldLocale) {
            fetchCuratedOffers();
        }
    });


    return {
        curatedOffers,
        loadingCurated,
        fetchCuratedOffers
    };
});